import React, {useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";
import {activityLinkUrl} from "../utils/activity-utils.js";
import {encounterStatusLabel} from "../../../../../utils/enums/encounter-status-enum.js";
import ActivityLink from "./activity-link.jsx";

const ActivityEncounterTable = ({encounters, boName}) => {
    const columnDefs = useMemo(() => [
        {
            field: "dtStart", headerName: "D/H inicial", width: 150,
            cellRenderer: ({data, value}) => (
                <ActivityLink to={activityLinkUrl.encounter(data?.encounterId)}>{value ?? ""}</ActivityLink>
            ),
        },
        {field: "dtEnd", headerName: "D/H final", width: 150},
        {
            field: "bogcmId", headerName: boName, width: 140,
            comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({value}) => (
                <ActivityLink to={activityLinkUrl.bo(value)}>{value ?? ""}</ActivityLink>
            ),
        },
        {field: "nameWar", headerName: "Abordagem por", flex: 1},
        {field: "justification", headerName: "Justificativa", flex: 1},
        {
            field: "status", headerName: "Status", width: 130,
            valueFormatter: ({value}) => encounterStatusLabel(value),
        },
        {field: "vehicleCount", headerName: "Veículos", width: 110},
        {field: "individualsCount", headerName: "Indivíduos", width: 120},
    ], [boName]);

    return (
        <AgGridReact
            domLayout="autoHeight"
            rowData={encounters}
            columnDefs={columnDefs}
            defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme({rowHeight: 40})}
            overlayNoRowsTemplate="Nenhum registro."
        />
    );
};

export default ActivityEncounterTable;
